import { render, staticRenderFns } from "./gongkuan.vue?vue&type=template&id=8a23b0ec&scoped=true&"
import script from "./gongkuan.vue?vue&type=script&lang=js&"
export * from "./gongkuan.vue?vue&type=script&lang=js&"
import style0 from "./gongkuan.vue?vue&type=style&index=0&id=8a23b0ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a23b0ec",
  null
  
)

export default component.exports